module.exports = __webpack_public_path__ + "static/media/r214.2bcfe220.jpg";